/*
 * Typewriter animation for a main-menu item (header setting "Animación de
 * menú"). Cycles the item title and the configured phrases: types each one,
 * holds it, erases it and continues. The first phrase is the menu title; the
 * others get the "secondary" style. Respects prefers-reduced-motion (static
 * title) and pauses while the tab is hidden.
 *
 * Author: NOVADEHA / Felipe Ocampo
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readPhrases(root) {
    return (root.getAttribute('data-phrases') || '').split('|||').map(function (p) { return p.trim(); }).filter(Boolean);
  }

  // Fixes the item width to the widest phrase in its own style (the title
  // in the main style, the rest in the secondary one) so the menu never
  // shifts while the text is typed and erased. A hidden item (closed mobile
  // drawer) measures 0, so it is retried on later ticks until visible.
  function reserveWidth(root, text, phrases) {
    var current = text.textContent;
    var secondary = root.classList.contains('babalu-tw--secondary');
    var widest = 0;
    for (var i = 0; i < phrases.length; i += 1) {
      text.textContent = phrases[i];
      root.classList.toggle('babalu-tw--secondary', i > 0);
      widest = Math.max(widest, root.getBoundingClientRect().width);
    }
    text.textContent = current;
    root.classList.toggle('babalu-tw--secondary', secondary);
    if (widest > 0) root.style.minWidth = Math.ceil(widest) + 'px';
    return widest > 0;
  }

  function start(root) {
    if (root.dataset.babaluTypewriterReady) return;
    root.dataset.babaluTypewriterReady = 'true';

    var phrases = readPhrases(root);
    var text = root.querySelector('.babalu-tw__text');
    if (!text || phrases.length < 2 || reduceMotion) return;

    // Measured on the first tick (after the initial hold), not during load.
    var reserved = false;
    var typeMs = Math.max(30, parseInt(root.dataset.typeMs, 10) || 90);
    var holdMs = Math.max(300, parseInt(root.dataset.holdMs, 10) || 1800);
    var eraseMs = Math.max(20, Math.round(typeMs / 2));
    var index = 0;
    var chars = phrases[0].length;
    var erasing = true;

    function render() {
      text.textContent = phrases[index].slice(0, chars);
      root.classList.toggle('babalu-tw--secondary', index > 0);
    }

    function tick() {
      // Desktop menu copies have no layout box on phones. Do not rewrite
      // every phrase and force layout repeatedly while the menu is hidden.
      if (document.hidden || !root.getClientRects().length) {
        window.setTimeout(tick, 500);
        return;
      }
      if (!reserved) reserved = reserveWidth(root, text, phrases);
      var phrase = phrases[index];
      var delay = typeMs;
      if (erasing) {
        chars -= 1;
        delay = eraseMs;
        if (chars <= 0) {
          chars = 0;
          erasing = false;
          index = (index + 1) % phrases.length;
          delay = typeMs * 3;
        }
      } else {
        chars += 1;
        if (chars >= phrase.length) {
          chars = phrase.length;
          erasing = true;
          delay = holdMs;
        }
      }
      render();
      window.setTimeout(tick, delay);
    }

    // The title is already visible: hold it first, then start erasing. The
    // loop only starts once the page has finished loading, so its frequent
    // repaints never compete with the critical rendering work on phones.
    function begin() { window.setTimeout(tick, holdMs); }
    if (document.readyState === 'complete') begin();
    else window.addEventListener('load', begin, { once: true });
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-babalu-typewriter]');
    for (var i = 0; i < nodes.length; i += 1) {
      try {
        start(nodes[i]);
      } catch (error) {
        // Decorative only: never break the menu.
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  // The mobile drawer menu is lazy-loaded into <hdt-lazy-submenu>, which
  // fires "lazyhtml:added" once its HTML is in place (same hook the theme's
  // custom.js uses). Listening to it costs nothing during page load, unlike
  // observing DOM mutations.
  function watchLazyMenu() {
    var lazy = document.querySelectorAll('hdt-lazy-submenu');
    for (var i = 0; i < lazy.length; i += 1) {
      lazy[i].addEventListener('lazyhtml:added', function () { init(); });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchLazyMenu);
  } else {
    watchLazyMenu();
  }
})();
